import SuperJSON from "superjson";
import Id from "../types/Id";

export default class TemplateId extends Id<"template"> {}

SuperJSON.registerClass(TemplateId, { identifier: "TemplateId" });
